import React, { FC } from 'react'
import classNames from 'classnames'
import { Element } from 'react-scroll'

import styles from './SectionLayout.module.scss'

type TSectionLayoutProps = {
  id: string
  className?: string
  children?: React.ReactNode
  addToRefs?: (el: HTMLDivElement) => void
}

const SectionLayout: FC<TSectionLayoutProps> = ({ id, className, addToRefs, children }) => (
  <section id={id} ref={addToRefs}>
    <Element name={id} className={classNames(styles.wrapper, className)}>
      {children}
    </Element>
  </section>
)

export default SectionLayout
